import React, { useState, useRef } from "react";
import Select from "react-select";
import style from "./HireTalent.module.css";
import { customStyles } from '../../helpers/constants';
import Header from "../../components/Header";
import HeaderMobile from "../../components/HeaderMobile";
import { HireATalentDash } from "../../assets";
import { useLocation, useNavigate } from "react-router-dom";
import { useMutation, useQuery } from "@tanstack/react-query";
import { addHireRequest, getRolesList, getSkillsList } from "../../api/containersApi";
import toast from "react-hot-toast";

export default function HireTalent() {

    const location = useLocation();    
    const navigate = useNavigate();
    const fileInputRef = useRef(null);
    const [validated, setValidated] = useState(true);
    const [formData, setFormData] = useState({
        name: '',
        phone: '',
        email: '',
        skillID: '',
        organisation: '',
        jobDes: '',
        message: '',
    });
    const [skillOption, setSkillOption] = useState(null);

    const { data: skillList, isLoading, isError, refetch } = useQuery({
        queryKey: ["getSkillsList"],
        queryFn: () => getSkillsList(localStorage.getItem("sessionToken")),
    });

    const skillsListMapped = skillList?.map((i) => ({
        value: i?.id,
        label: i?.skill_name,
    }));

    const { mutate } = useMutation({
        mutationKey: ["addHireRequest"],
        mutationFn: addHireRequest,
        onSuccess: (data) => {
            toast.success("Thank you! Your Hiring Request has been generated successfully.", {
                position: "bottom-center",
                duration: 10000,
                style: {
                    border: '1px solid #FF9900',
                    padding: '16px',
                    color: "black",
                    fontFamily: "Helvetica",
                    minWidth: "350px",
                  },
                  iconTheme: {
                    primary: '#FF9900',
                    secondary: '#FFFAEE',
                  },
            });
            window.scrollTo({top: 0, behavior: "smooth"})
            setFormData({
                name: '',
                phone: '',
                email: '',
                skillID: '',
                organisation: '',
                jobDes: '',
                message: '',
            })
            setSkillOption(null);
            fileInputRef.current.value = ''
        },
    });

    const submitForm = async (e) => {
        const finalFormData = new FormData();
        finalFormData.append("name", formData?.name);
        finalFormData.append("phone", formData?.phone);
        finalFormData.append("email", formData?.email?.trim());
        finalFormData.append("role", formData?.skillID);
        finalFormData.append("organisation", formData?.organisation);
        finalFormData.append("jobDes", formData?.jobDes);
        finalFormData.append("message", formData?.message);
        
        mutate(
            {
                auth_key: localStorage.getItem("sessionToken"),
                finalFormData: finalFormData
            }
        );
    }

    return(

        <div className={style.HireATalent_section}>

            <HeaderMobile />

            <div className={style.HireATalentDash_container}>

                <Header />

                {/* for larger screens */}
                <div className={style.HireATalentDash_content}>
                    <div data-aos="fade-right" data-aos-duration="1000" data-aos-delay="200">
                        <p>Discover Top Talent and Elevate Your Team!</p>
                        <p>Find top talent and expand your team with our exceptional opportunities. Let’s build success together!</p>
                    </div>
                    <div data-aos="fade-left" data-aos-duration="1000" data-aos-delay="300">
                        <img src={HireATalentDash} alt="HireATalent" />
                    </div>
                </div>

                {/* for smaller screens */}
                <img src={HireATalentDash} alt="Hire a talent" />
                <div className={style.HireATalentDash_content_2}>
                    <p>Discover Top Talent and Elevate Your Team!</p>
                    <p>Find top talent and expand your team with our exceptional opportunities. Let’s build success together!</p>
                </div>
                
            </div>

            <section className={style.textSection}>
                {/* data-aos="zoom-in" data-aos-duration="800" */}
                <p>Enroll and witness our meticulous process of filtering out the ordinary to deliver extraordinary candidates. At NuFolks, we prioritize excellence by curating a pool of top-tier talent that meets your unique needs and exceeds your expectations. Partner with us to elevate your workforce and achieve exceptional results.</p>
            </section>

            <section data-aos="fade-up" data-aos-duration="1500" className={style.formSection}>
                <h1>Looking To Hire</h1>
                <p>Let NuFolks help you find the talent your organization needs. Share your details and service requirements with us, and we'll work together to meet your staffing needs efficiently and effectively.</p>
                <form 
                    data-aos="fade-up" 
                    data-aos-duration="1000" 
                    data-aos-offset="0" 

                    onSubmit={(e) => {
                        e.preventDefault();
                        if(formData?.name === "" || formData?.phone === undefined || formData?.email === "" || formData?.organisation === "" || formData?.skillID === undefined || formData?.jobDes === null){
                            setValidated(false);
                            return;
                        }
                        else{
                            setValidated(true);
                            submitForm(e);
                        }
                    }}

                >
                    <div className={style.formComponent}>
                        <label htmlFor="name">Name</label>
                        <input 
                            id="name"
                            name="name"
                            type="text" 
                            placeholder="Enter Your Full Name" 
                            value={formData.name}
                            // onChange={handleChange}
                            onChange={(e) => {
                                setFormData({...formData, name: e.target.value})
                            }}
                        />
                        { !validated && !formData?.name && <p>Please, enter your Full Name</p> }
                    </div>
                    
                    <div className={style.formComponent}>
                        <label htmlFor="phone">Phone Number</label>
                        <input 
                            id="phone"
                            name="phone"
                            type="tel"
                            pattern="[0-9]*"  
                            maxLength={10}
                            placeholder="Enter valid 10-digit Phone Number" 
                            value={formData?.phone}
                            onChange={(e) => {
                                const filteredValue = e.target.value.replace(/\D/g, "");
                                setFormData({...formData, phone: filteredValue})
                            }}
                            // onChange={handleChange}
                        />
                        { !validated && !formData?.phone && <p>Please, enter valid 10-digit Phone Number</p> }
                        {/* <p style={{color: 'red', fontSize: '12px'}}>Please enter the required</p> */}
                    </div>

                    <div className={style.formComponent}>
                        <label htmlFor="email">Email Id</label>
                        <input 
                            id="email"
                            name="email"
                            type="email" 
                            placeholder="Eg. candidate@gmail.com" 
                            value={formData.email}
                            onChange={(e) => {
                                setFormData({...formData, email: e.target.value})
                            }}
                            // onChange={handleChange}
                        />
                        {/* <p style={{color: 'red', fontSize: '12px'}}>Please enter the required</p> */}
                        { !validated && !formData?.email && <p>Please, enter your email address</p> }                        
                    </div>

                    <div className={style.formComponent}>
                        <label htmlFor="employer_services">Role You're Seeking</label>
                        <div className={style.employer_list_div}> 
                            <Select
                                style={{width: "100%"}}
                                id="employer_services"
                                options={skillsListMapped}
                                placeholder="Select a Role"
                                styles={customStyles}
                                // value={rolesListMapped?.find((roleObject) => (roleObject?.value === formData?.role))}
                                // onChange={handleSelectChange}
                                value={skillOption}
                                onChange={(skillObject) => {
                                    setSkillOption(skillObject);
                                    setFormData({...formData, skillID: skillObject?.value})
                                }}
                            />
                        </div>
                        { !validated && !formData?.skillID && <p>Please, select a role</p> }                        
                    </div>

                    <div className={style.formComponent}>
                        <label htmlFor="organizatonName">Organisation Name</label>
                        <input 
                            id="organizatonName"    
                            name="organizatonName"
                            type="text" 
                            placeholder="Enter Your Organisation Name" 
                            value={formData.organisation}
                            onChange={(e) => {
                                setFormData({...formData, organisation: e.target.value})
                            }}
                        />
                        { !validated && !formData?.organisation && <p>Please, enter your Organizaton Name</p> }                        
                    </div>

                    <div className={style.formComponent}>
                        <label htmlFor="">Upload JD</label>
                        <input 
                            ref={fileInputRef}                        
                            id="fileMode" 
                            type="file" 
                            onChange={(e) => {
                                const file = e.target.files[0];
                                if (file) {
                                    setFormData({...formData, jobDes: file});
                                }
                            }}
                        />
                        { !validated && !formData?.jobDes && <p>Please, upload a valid Job Description</p> }
                    </div>

                    <div className={style.formComponent2}>
                        <label htmlFor="txtar">Message</label>
                        <textarea  
                            id="txtar" 
                            placeholder="Enter Your Message"
                            value={formData?.message}
                            onChange={(e) => {
                                setFormData({...formData, message: e.target.value})
                            }}
                        ></textarea>
                    </div>
                    <div className={style.formComponent3}>
                        <button>Submit</button>
                    </div>
                </form>
            </section>
            
        </div>
    )
}